// ----------------------------------------------------------------
import { createFileRoute } from '@tanstack/react-router';
import QcWidgetsPreviewPage from '@/pages/qc-widgets';
// ----------------------------------------------------------------

/**
 * Preview route for the orchestrator QC widget grid on sample data.
 * This is a route setup for '/qc-widgets/' route.
 */
export const Route = createFileRoute('/_authenticated-layout/qc-widgets/')({
  component: QcWidgetsPreviewPage,
});
